module.exports = __webpack_public_path__ + "img/email.3d2aabbf.png";